import { useContext } from "react";
import {sharedDataContext} from '../redux/context/dataProvider'


const useSharedData = () => {
    return useContext(sharedDataContext);
}

export default useSharedData;